<mode-time-ago *ngIf="showTimeAgo; else timeTemplate"
  [date]="timestamp"
  format="capitalized"
></mode-time-ago>

<ng-template #timeTemplate>
  <span data-test="date-time-display-value">
    {{ time }}
  </span>
</ng-template>
